// // src/firebase.js
// import { initializeApp } from 'firebase/app';
// import { getAuth } from 'firebase/auth';

// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCfPBVN_p6yQoN9Ho2PD-XWYeE_XUf5A9I",
//   authDomain: "reseller-93b66.firebaseapp.com",
//   databaseURL: "https://reseller-93b66-default-rtdb.firebaseio.com",
//   projectId: "reseller-93b66",
//   storageBucket: "reseller-93b66.firebasestorage.app",
//   messagingSenderId: "496663423082",
//   appId: "1:496663423082:web:5f6de63d7b6983b2e98213",
//   measurementId: "G-XEHTYK57Z8"
// };

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);

// export { auth };




// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage'; // Add Storage import

const firebaseConfig = {
  apiKey: "AIzaSyAsMR7FW8boGygnRABrpo5TJudGVcPSEcQ",
  authDomain: "imprint24-c0c86.firebaseapp.com",
  databaseURL: "https://imprint24-c0c86-default-rtdb.firebaseio.com",
  projectId: "imprint24-c0c86",
  storageBucket: "imprint24-c0c86.firebasestorage.app",
  messagingSenderId: "1060919076727",
  appId: "1:1060919076727:web:5cec808c59729ae36ce372",
  measurementId: "G-XD5W4MFFNC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const database = getDatabase(app);
const storage = getStorage(app); // Initialize Storage service

// Export all services
export { auth, database, storage };





















